<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      A tool made by
      <b-link
        class="ml-25"
        href="https://twitter.com/TZMCrypto"
        target="_blank"
      >TZM</b-link>
    </span>
    <span style="margin-left: 7px;" class="float-md-right d-none d-md-block">
      Price feeds from
      <b-link
        class="ml-25"
        href="https://coingecko.com "
        target="_blank"
      >CoinGecko </b-link>
    </span>
    <span class="float-md-right d-none d-md-block">
      Data provided by
      <b-link
        class="ml-25"
        href="https://flipsidecrypto.xyz"
        target="_blank"
      >flipsidecrypto </b-link>-
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
